import React, { memo } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import {
  StyledTariffItem,
  TariffItemTitle,
  TariffItemPromoLabel,
  TariffItemPrice,
  TariffItemDuration,
} from './StyledComponents';

const TariffItem = props => {
  const { item, id, index, onFocus, onEnter } = props;

  let price = item.amount && i18n.t('detailsTariffs.price', { amount: item.amount });
  let title = item.duration ? i18n.t('detailsTariffs.rent') : i18n.t('detailsTariffs.buy');
  let duration = item.duration
    ? i18n.t('detailsTariffs.duration', { count: item.duration })
    : i18n.t('common.forever');

  if (item.promoAmount) {
    price = i18n.t('detailsTariffs.price', { amount: item.promoAmount });
  }

  if (item.isSubscription) {
    title = i18n.t('detailsTariffs.buySubscription');
    duration = null;
  }

  return (
    <StyledTariffItem
      isSubscriptionItem={item.isSubscription}
      onFocus={() => onFocus(index)}
      onEnter={() => onEnter(index)}
      id={id}
      focusOnMouseEnter
    >
      <TariffItemTitle>{title}</TariffItemTitle>
      {item.promoAmount && (
        <TariffItemPromoLabel>{i18n.t('detailsTariffs.promotion')}</TariffItemPromoLabel>
      )}
      {price && <TariffItemPrice>{price}</TariffItemPrice>}
      {duration && <TariffItemDuration>{duration}</TariffItemDuration>}
    </StyledTariffItem>
  );
};

TariffItem.propTypes = {
  item: PropTypes.shape({
    amount: PropTypes.number,
    promoAmount: PropTypes.number,
    duration: PropTypes.number,
    isSubscription: PropTypes.bool,
  }).isRequired,
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onFocus: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
};

export default memo(TariffItem);
